<template>
  <div class="pool-sidebar">
    <b-tabs justified>
      <b-tab>
        <template #title
          ><settings-icon />
          {{ $t("portfolioManager.poolSidebar.settingsTabName") }}</template
        >
        <settings-sidebar-tab />
      </b-tab>
      <b-tab title="My Portfolios">
        <template #title
          ><list-icon />
          {{ $t("portfolioManager.poolSidebar.portfoliosTabName") }}
        </template>
        <portfolios-sidebar-tab />
      </b-tab>
    </b-tabs>
    <div class="buttons-container">
      <b-button variant="blank" @click="handleAddNew">
        <add-icon :fillColor="iconFill" />
      </b-button>
      <b-button variant="blank" v-b-modal.export-portfolio-modal>
        <download-icon :fillColor="iconFill" />
      </b-button>
    </div>
    <export-portfolio-modal />
  </div>
</template>

<script>
import AddIcon from "vue-material-design-icons/PlusCircleOutline";
import DownloadIcon from "vue-material-design-icons/DownloadCircleOutline";
import ExportPortfolioModal from "../modals/ExportPortfolioModal.vue";
import { ICONS_FILL_COLOR } from "../../utils/constants";
import ListIcon from "vue-material-design-icons/ViewList.vue";
import PortfoliosSidebarTab from "../PortfoliosSidebarTab.vue";
import SettingsIcon from "vue-material-design-icons/Tune.vue";
import SettingsSidebarTab from "../SettingsSidebarTab.vue";
import { mapActions } from "vuex";
export default {
  components: {
    AddIcon,
    DownloadIcon,
    ExportPortfolioModal,
    ListIcon,
    SettingsIcon,
    SettingsSidebarTab,
    PortfoliosSidebarTab,
  },
  props: {
    dataSince: Date,
  },
  name: "pool-sidebar",
  data() {
    return {
      iconFill: ICONS_FILL_COLOR,
    };
  },
  methods: {
    ...mapActions("portfolioManagerStore", ["clearPortfolio"]),
    handleAddNew() {
      this.clearPortfolio(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.pool-sidebar {
  position: relative;
  @media screen and (min-width: 1024px) {
    position: fixed;
    width: toRem(240);
    max-height: 100vh;
  }
}
.buttons-container {
  position: absolute;
  top: 45px;
  right: 0;
  display: flex;
  justify-content: flex-end;
  .btn {
    padding: 0;
    .button-text {
      max-width: 0;
      -webkit-transition: max-width 0.5s;
      transition: max-width 0.5s;
      display: inline-block;
      vertical-align: top;
      white-space: nowrap;
      overflow: hidden;
    }
    &:hover {
      .button-text {
        max-width: 7rem;
      }
    }
  }
}
</style>